// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0d2faab0","829":"5b1ec34a"}[chunkId] + ".chunk.js";
};